import { AlertTriangle, X } from "lucide-react";
import { useTranslation } from "../../i18n";

interface Props {
    missing: string[];
    archived: string[];
    onConfirm: () => void;
    onCancel: () => void;
}

const MissingSuppliersModal = ({ missing, archived, onConfirm, onCancel }: Props) => {
    const { t } = useTranslation();
    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div
                className="modal-card"
                onClick={e => e.stopPropagation()}
                role="dialog"
                aria-labelledby="missing-suppliers-title"
            >
                <div className="modal-card-header">
                    <h2 id="missing-suppliers-title">
                        <AlertTriangle size={18} style={{ marginRight: 8, verticalAlign: "-3px" }} />
                        {t("suppliers_preflight_title")}
                    </h2>
                    <button
                        type="button"
                        className="modal-close"
                        onClick={onCancel}
                        aria-label={t("close")}
                    >
                        <X size={18} />
                    </button>
                </div>
                <div className="modal-card-body">
                    {missing.length > 0 && (
                        <>
                            <p>{t("suppliers_preflight_body_missing")}</p>
                            <ul className="missing-suppliers-list">
                                {missing.map(n => <li key={`m-${n}`}>{n}</li>)}
                            </ul>
                        </>
                    )}
                    {archived.length > 0 && (
                        <>
                            <p>{t("suppliers_preflight_body_archived")}</p>
                            <ul className="missing-suppliers-list">
                                {archived.map(n => <li key={`a-${n}`}>{n}</li>)}
                            </ul>
                        </>
                    )}
                    <p style={{ marginTop: 12, color: "var(--color-text-muted, #64748b)", fontSize: "0.875rem" }}>
                        {t("suppliers_preflight_cancel_hint")}
                    </p>
                </div>
                <div className="modal-confirm-buttons">
                    <button type="button" className="btn btn-ghost" onClick={onCancel}>
                        {t("cancel")}
                    </button>
                    <button type="button" className="btn btn-primary" onClick={onConfirm}>
                        {t("suppliers_preflight_confirm")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MissingSuppliersModal;
